export const siteSettings = {
  name: "Korex",
  link: "https://korexpro.com",
  email: "support@korexpro.com",
  appLink: "https://app.korexpro.com",
};
